// extracted by mini-css-extract-plugin
module.exports = {"error":"list_error__c2Vuo"};